import { createIcon } from "@chakra-ui/react";

const FormatH1Icon = createIcon({
  displayName: "FormatH1Icon",
  viewBox: "0 0 24 24",
  path: <path d="M5 17V7h2v4h4V7h2v10h-2v-4H7v4H5Zm12 0V9h-2V7h4v10h-2Z" fill="currentColor" />,
});

export default FormatH1Icon;
